export default "__VITE_ASSET__BsccCEbl__"